import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/pricing/page.tsx");
